// extracted by mini-css-extract-plugin
module.exports = {"products":"kQ","misad":"lQ","oosMessaging":"mQ","topProductFrame":"nQ","facetClass":"oQ","productCardOverrides":"pQ","microsoftAdsWrapper":"qQ","firstRow":"rQ"};